import React, { useState } from "react";
import { FaDownload } from "react-icons/fa6";
import {
  Center,
  Icon,
  Spinner,
  Stack,
  Table,
} from "@chakra-ui/react";
import { Text } from "@/components";
import { UploadedDocument } from "@/types";

type DocumentsTableProps = {
  documents: UploadedDocument[]
  handleDownloadDocument: (name: string) => void
};

const DownloadDocumentButton = ({ name, handleDownloadDocument }: { name: string, handleDownloadDocument: (name: string) => void }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const onDownloadDocument = async () => {
    setIsLoading(true);
    await handleDownloadDocument(name);
    setIsLoading(false);
  }

  return (
    <Center
      border="1px solid #E2E8F0"
      borderRadius={5}
      boxSize={8}
      cursor="pointer"
      _hover={{ bg: "gray.200" }}
      onClick={onDownloadDocument}
    >
      {
        isLoading ? (
          <Spinner size="sm" />
        ) : <Icon as={FaDownload as React.ElementType} color="text.primary" />
      }
    </Center>
  )
}

export const DocumentsTable: React.FC<DocumentsTableProps> = ({ documents, handleDownloadDocument }) => {
  return (
    <Stack w="100%" pt={10} pb={10}>
      <Table.Root striped colorScheme="gray">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader><Text fontWeight="bold">Document Name</Text></Table.ColumnHeader>
            <Table.ColumnHeader><Text fontWeight="bold">Type</Text></Table.ColumnHeader>
            <Table.ColumnHeader><Text fontWeight="bold">Date</Text></Table.ColumnHeader>
            <Table.ColumnHeader><Text fontWeight="bold">Uploaded By</Text></Table.ColumnHeader>
            <Table.ColumnHeader textAlign="center"></Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {documents.map((doc) => (
            <Table.Row key={doc.name}>
              <Table.Cell>
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                >
                  {doc.name}
                </Text>
              </Table.Cell>
              <Table.Cell>
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                >
                  {doc.type}
                </Text>
              </Table.Cell>
              <Table.Cell>
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                >
                  {new Intl.DateTimeFormat("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                  }).format(new Date(doc.date))}
                </Text>
              </Table.Cell>
              <Table.Cell>
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                >
                  {doc.uploadedBy}
                </Text>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <DownloadDocumentButton name={doc.name} handleDownloadDocument={handleDownloadDocument} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Stack>
  )
}